module.exports = __webpack_public_path__ + "assets/img/qq.ace072ea.png";